<input v-model="val" type="text" :class="{ error }" @blur="touch" @keyup.enter="save">